import {
    CommonModule,
    DatePipe,
    DecimalPipe,
    HashLocationStrategy,
    LocationStrategy,
    registerLocaleData,
} from "@angular/common";
import { HttpClient, provideHttpClient, withFetch } from "@angular/common/http";
import {
    CUSTOM_ELEMENTS_SCHEMA,
    Injector,
    LOCALE_ID,
    NgModule,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";

// PrimeNG
import { ConfirmationService, MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LayoutModule } from "./components/layout/layout.module";
import { definePreset } from "@primeng/themes";
import Material from '@primeng/themes/material';

// Locale PT-BR
import localePtBR from "@angular/common/locales/pt";
registerLocaleData(localePtBR);

// NGX Translate
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { providePrimeNG } from "primeng/config";
import { AppRoutingModule } from "./app-routing.module";
import { Symbols } from "./core/cdi/symbols";
import { LocalStorageServiceImpl } from "./core/services/storage/impl/local-storage.service.impl";
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

export var AppInjector: Injector;

const MyPreset = definePreset(Material, {
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});

@NgModule({
    // OBS: Todos componentes que for usar no LayoutComponent deve ser declarado aqui e não no shared. E tambem nao pode extender AbstractControllerBase
    declarations: [
        AppComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        // Internal
        LayoutModule,
    ],
    exports: [TranslateModule],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LOCALE_ID, useValue: "pt-BR" },
        provideHttpClient(withFetch()),
        provideAnimationsAsync(),
        providePrimeNG({
            ripple: true,
            inputStyle: 'outlined',
            theme: { preset: MyPreset, options: { darkModeSelector: '.app-dark' } }
        }),
        // {
        //     provide: Symbols.AuthenticationServiceInterface,
        //     useClass: AuthenticationServiceImpl,
        // },
        {
            provide: Symbols.StorageServiceInterface,
            useClass: LocalStorageServiceImpl,
        },
        DatePipe,
        DecimalPipe,
        MessageService,
        DialogService,
        ConfirmationService,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
    constructor(private injector: Injector) {
        AppInjector = this.injector;
    }
}
